import Api from "@/services/api";
import PersonalizerApi from "@/services/personalizer_api";
import { ENDPOINT_PATHS, ENDPOINT_TYPES, MAIRA_QUESTIONNAIRE_INIT_DATA } from "@/global/_constants";
import { pRole } from "@/helpers/role";
import {
  ASSIGN_PROJECT_MEMBERS,
  CREATE_BROADCAST_MESSAGE,
  CREATE_GPT_DATASET,
  CREATE_GPT_DATASET_TS,
  CREATE_GPT_PROFILE,
  CREATE_GPT_SETTINGS,
  CREATE_GUEST_LINK,
  CREATE_INDICES,
  CREATE_IP_ACCESS,
  CREATE_MAPPER,
  CREATE_RANK,
  CREATE_SETTINGS,
  DB_GET_TASKS_STATUS,
  DB_STORE_TASKS_STATUS,
  DELETE_BROADCAST_MESSAGE,
  DELETE_EMAIL_CONFIG,
  DELETE_EMAIL_RECIPIENT,
  DELETE_EMAIL_TEMPLATE,
  DELETE_GPT_PROFILE,
  DELETE_GPT_SETTINGS,
  DELETE_IP_ACCESS,
  DELETE_MAIRA_QUESTIONNAIRE,
  DELETE_PROJECT_MEMBERS,
  ENCRYPT_EXTERNAL_SYSTEM_DATA,
  FETCH_PROFILE_CONVERSATION_INSIGHTS,
  FETCH_SHAREABLE_DATA,
  GENERATE_CONVERSATION_HISTORY,
  GENERATE_FILE,
  GENERATE_MAIRA_QUESTIONNAIRE_HISTORY,
  GENERATE_QUESTIONNAIRE_LOGS,
  GENERATE_SESSION_HISTORY,
  GET_ALL_IP_ACCESS,
  GET_ALL_TASKS,
  GET_BROADCASTS_MESSAGE,
  GET_CATALOG_ITEMS,
  GET_CONVERSATION_HISTORY_COLUMNS,
  GET_COUNTRY_LIST,
  GET_DEFAULT_CATEGORIES,
  GET_EMAIL_RECIPIENT,
  GET_EMAIL_TEMPLATE,
  GET_GPT_DATASET_BY_ID,
  GET_GPT_DATASETS,
  GET_GPT_DATASETS_SUMMARY,
  GET_GPT_MODEL_DETAILS,
  GET_GPT_MODELS,
  GET_GPT_PROFILE_BY_ID,
  GET_GPT_PROFILES,
  GET_GPT_SETTINGS,
  GET_GUEST_LINKS,
  GET_INDICES,
  GET_MAIRA_OPTIONS,
  GET_MAIRA_QUESTIONNAIRE,
  GET_MAPPER,
  GET_PREVIOUSLY_SETUP_STATE,
  GET_QUESTIONNAIRE_RESPONSE_DETAIL,
  GET_QUESTIONNAIRE_RESPONSES,
  GET_RANK_SETTINGS,
  GET_SESSION_HISTORY_COLUMNS,
  GET_SETTINGS,
  GET_TASKS_STATUS,
  IMAGES_TRAIN,
  INITIATE_OAUTH_LOGIN,
  ITEMS_TRAIN,
  LOAD_ALL_CREDENTIAL,
  LOAD_ALL_PROJECT,
  LOAD_EMAIL_CONFIGS,
  LOAD_EMAIL_PROVIDERS,
  LOAD_EMAIL_RECIPIENTS,
  LOAD_EMAIL_TEMPLATES,
  LOAD_PROJECT_BY_ID,
  LOAD_PROJECT_COST,
  LOAD_PROJECT_COUNTS,
  LOAD_TRAIN_TASKS,
  MAIRA_QUESTIONNAIRE,
  POST_MAIRA_QUESTIONNAIRE,
  RANKS_TRAIN,
  REINDEX_PROJECT,
  REMOVE_CATALOG_ITEMS,
  RETRIEVE_PROJECT_MEMBERS,
  SAVE_CREDENTIAL,
  SAVE_EMAIL_RECIPIENT,
  SAVE_EMAIL_TEMPLATE,
  SAVE_PROJECT,
  SAVE_SMTP_CONFIG,
  SET_PROJECT_ROLE,
  START_PROJECT,
  STOP_PROJECT,
  TERMINATE_GPT_DATASET,
  TERMINATE_PROJECT,
  TRAIN_GPT_DATASET,
  UPDATE_BROADCAST_MESSAGE,
  UPDATE_CATALOG_ITEM,
  UPDATE_CREDENTIAL,
  UPDATE_EMAIL_CONFIG_STATUS,
  UPDATE_EMAIL_RECIPIENT,
  UPDATE_EMAIL_TEMPLATE,
  UPDATE_GPT_DATASET_API,
  UPDATE_GPT_DATASET_FILE,
  UPDATE_GPT_DATASET_STATE,
  UPDATE_GPT_DATASET_TS_FILE,
  UPDATE_GPT_PROFILE_API,
  UPDATE_GPT_PROFILE_STATE,
  UPDATE_GPT_SETTINGS,
  UPDATE_GPT_SETUP_STATE,
  UPDATE_GUEST_LINK,
  UPDATE_IP_ACCESS,
  UPDATE_MAIRA_OPTIONS,
  UPDATE_MAIRA_QUESTIONNAIRE,
  UPDATE_MAPPER,
  UPDATE_PROJECT,
  UPDATE_PROJECT_MEMBERS,
  UPDATE_QUESTIONNAIRE_RESPONSE,
  CONNECT_CLOUD_STORAGE,
  GET_CLOUD_STORAGE_FILES,
  GET_CLOUD_STORAGE_ITEMS,
  DOWNLOAD_CLOUD_FILE,
  VALIDATE_CLOUD_SELECTION,
  GET_CLOUD_STORAGE_ACCOUNTS,
  COMPLETE_CLOUD_STORAGE,
  DISCONNECT_CLOUD_STORAGE,
  UPDATE_RANK_SETTINGS,
  UPDATE_SETTINGS,
  UPGRADE_SUBSCRIPTION,
  UPLOAD_RECOMMENDER_DATA,
  GET_GUEST_LINKS_USERS,
  RESET_GUEST_LINK_USER_PASSWORD,
  UPDATE_PROJECT_DIRECT_LINK_ACCESS_TYPE,
} from "@/store/_actiontypes";
import {
  CATALOG_SCROLL_ID_STACK,
  CLEAR_SELECTED_QUESTIONNAIRE,
  SET_ALL_CREDENTIAL,
  SET_ALL_IP_ACCESS,
  SET_ALL_PROJECT,
  SET_BROADCASTS_MESSAGE,
  SET_CATALOG_ITEMS,
  SET_COUNTRY_LIST,
  SET_DEFAULT_CATEGORIES,
  SET_EMAIL_CONFIGS,
  SET_EMAIL_PROVIDERS,
  SET_EMAIL_RECIPIENTS,
  SET_EMAIL_TEMPLATES,
  SET_ENCRYPT_RESPONSE,
  SET_GPT_DATASET,
  SET_GPT_DATASET_SUMMARY,
  SET_GPT_DATASETS,
  SET_GPT_MODELS,
  SET_GPT_PROFILE,
  SET_GPT_PROFILES,
  SET_GPT_PROVIDERS,
  SET_GPT_SETUP_STATE,
  SET_MAIRA_OPTIONS,
  SET_MAIRA_QUESTIONNAIRE,
  SET_MAPPER,
  SET_PREVIOUSLY_SETUP_STATE,
  SET_PROJECT_ASSIGNED_MEMBERS,
  SET_PROJECT_BY_ID,
  SET_PROJECT_COST,
  SET_PROJECT_COUNTS,
  SET_PROJECT_SETUP_STATE,
  SET_SHAREABLE_DATA,
  SET_TRAIN_TASKS,
  UPDATE_SELECTED_PROJECT,
} from "@/store/_mutationtypes";
import { GptProfileMapper } from "@/helpers/dataMappers/gptProfile";
import { GptDatasetMapper } from "@/helpers/dataMappers/gptDataset";
import { updateLoaderTo } from "./account";
import { isTextExtractableFile, removeOcrMetadata } from "@/helpers/helper";

export const gptProfileInitialData = GptProfileMapper.mapBackendToFrontend();
export const gptDatasetInitialData = GptDatasetMapper.mapBackendToFrontend({
  dataset_id: "",
  description: "",
  idx_column_name: "",
  image_url_column: "",
  is_idx_fillup_if_empty: true,
  name: "",
  secondary_idx_column: "",
  social_media_type: "x",
  country_code: null,
});

const state = {
  allProject: [],
  project_role: "",
  selectedProject: {},
  mapper: null,
  projectCost: {},
  allCredential: [],
  trainTasks: [],
  previouslySetupState: [],
  projectCounts: [],
  catalogItems: [],
  gptModels: [],
  gptProviders: [],
  gptProfiles: {
    profiles: [],
    returned_hits: 0,
    total_hits: 0,
  },
  selectedGptProfile: gptProfileInitialData,
  selectedMairaQuestionnaire: MAIRA_QUESTIONNAIRE_INIT_DATA(),
  gptDatasets: {
    datasets: [],
    returned_hits: 0,
    total_hits: 0,
  },
  selectedGptDataset: gptDatasetInitialData,
  initialGptDatasetTrainingState: {},
  gptSetupState: {
    completed: false,
    gpt_profile: {
      completed: false,
      skipped: false,
      profile_id: null,
    },
    default_profile: { completed: false },
    dataset: {
      task_id: null,
      status: null,
      dataset_id: null,
      completed: false,
      skipped: false,
    },
    training: {
      task_id: null,
      status: null,
      completed: false,
      skipped: false,
    },
  },

  gptDatasetSummary: {},
  catalogScrollIdStack: [],
  projectMembers: [],
  mairaOptions: {},
  datasetType: "regular",
  contentSource: "webUrl",

  shareableData: null,
  defaultCategories: [],
  encryptResponse: null,
  fallbackCategories: ["hate speech", "prank", "profanity", "self harm", "sexual", "spam links", "violence"],

  fallbackShareableData: {
    profile_id: "Profile Id",
    profile_name: "Profile Name",
    project_id: "Project Id",
    session_id: "Session Id",
    user_id: "User Id",
    username: "User Name",
  },
  emailConfigs: {
    items: [],
    total: 0,
  },
  emailProviders: [],
  emailRecipients: {
    items: [],
    total: 0,
  },
  emailTemplates: {
    items: [],
    total: 0,
  },
  broadcasts: {
    items: [],
    total: 0,
  },
  assignedMembers: [],
};

const getters = {
  mapper: state => state.mapper,
  credentials: state => {
    return state.allCredential.map(credential => {
      const { key_type, key_metadata } = credential;

      const whitelists = key_metadata && key_metadata.whitelists ? key_metadata.whitelists : [];

      let riskLevel = "No Risk";
      let color = "green";

      if (key_type === "client") {
        if (whitelists.length === 0 || whitelists.includes("localhost")) {
          riskLevel = "High Risk";
          color = "error";
        }
      } else {
        // key_type === 'project'
        if (whitelists.length === 0) {
          riskLevel = "Medium";
          color = "warning";
        } else if (whitelists.includes("localhost")) {
          riskLevel = "High Risk";
          color = "error";
        }
      }

      const security = {
        level: riskLevel,
        color: color,
        textColor: "white",
      };

      return {
        ...credential,
        security: security,
      };
    });
  },
  emailConfigs: state => state.emailConfigs,
  emailProviders: state => state.emailProviders,
  emailRecipients: state => state.emailRecipients,
  emailTemplates: state => state.emailTemplates,
};

const actions = {
  [LOAD_ALL_PROJECT]({ commit }, { solution_type }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const apiUrl = solution_type ? `projects?solution_type=${solution_type}` : "projects";

      Api.get(apiUrl).then(
        response => {
          let allProject = (response?.data?.projects || []).filter(project => project.project_role !== pRole.GUEST);
          // allProject.forEach((element) => {
          // element.projects_solutions = element.solutions.filter(
          //   (obj) => {
          //     return obj.enable === true;
          //   }
          // );
          // });
          commit(SET_ALL_PROJECT, allProject);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [TRAIN_GPT_DATASET]({ commit }, { project_id, datasetId, trainType, batchSize }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const trainingDataset = {
        batch_size: batchSize,
        train_type: trainType,
      };
      PersonalizerApi.post(
        `gpt/datasets/${datasetId}/train`,
        {
          ...trainingDataset,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_PROFILE_BY_ID]({ commit }, { project_id, profile_id }) {
    updateLoaderTo(true);
    commit(SET_GPT_PROFILE, gptProfileInitialData);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/profiles/${profile_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(
            SET_GPT_PROFILE,
            response.data?.detail?.response
              ? GptProfileMapper.mapBackendToFrontend(response.data?.detail?.response)
              : gptProfileInitialData
          );
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_GPT_PROFILE]({ commit, state }, { project_id, profile }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const mappedGPTProfileData = GptProfileMapper.mapFrontendToBackend(profile);
      PersonalizerApi.post(
        `gpt/profiles`,
        { ...mappedGPTProfileData },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          commit(SET_GPT_PROFILE, {
            ...profile,
            id: response.data?.detail?.profile_id,
          });
          commit(SET_GPT_PROFILES, {
            profiles: [{ ...profile, id: response.data?.detail?.profile_id }, ...state.gptProfiles.profiles],
            returned_hits: state.gptProfiles.returned_hits + 1,
            total_hits: state.gptProfiles.total_hits + 1,
          });
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  //creates default profile
  [CREATE_GPT_SETTINGS]({ commit }, { project_id, default_profile, default_vision_profile }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `gpt/settings`,
        {
          default_profile,
          default_vision_profile,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_SETTINGS]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/settings`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_GPT_SETTINGS]({ commit }, { project_id, gptSetting }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(
        `gpt/settings`,
        { ...gptSetting },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_GPT_SETTINGS]({ commit }, { project_id, default_profile, default_vision_profile, bot_mode_strict }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `gpt/settings`,
        { default_profile, default_vision_profile, bot_mode_strict },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_SETTINGS]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/settings`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [DELETE_GPT_SETTINGS]({ commit }, { project_id, fields = [] }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`gpt/settings`, {
        headers: {
          "Content-Type": "application/json",
          "project-id": project_id,
        },
        data: { fields },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  [DELETE_GPT_PROFILE]({ commit, state }, { project_id, profile_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`gpt/profiles/${profile_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          const updatedGptProfiles = state.gptProfiles.profiles.filter(item => item.id !== profile_id);
          commit(SET_GPT_PROFILES, {
            ...state.gptProfiles,
            profiles: updatedGptProfiles,
          });
          commit(SET_GPT_PROFILE, {
            ...gptProfileInitialData,
            id: profile_id,
          });
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_GPT_PROFILE_API]({ commit }, { project_id, profile }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const mappedGPTProfileData = GptProfileMapper.mapFrontendToBackend(profile);
      delete mappedGPTProfileData.id;
      PersonalizerApi.put(
        `gpt/profiles/${profile.id}`,
        {
          ...mappedGPTProfileData,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          // commit(SET_GPT_PROFILE, profile_data);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_BROADCASTS_MESSAGE](
    { commit },
    { project_id, profile_id, status, delivery_mode, search, sort_by, start = 0, size = 50 }
  ) {
    updateLoaderTo(true);
    const payload = {
      start,
      size,
    };
    if (profile_id) payload.profile_ids = [profile_id];
    if (status) payload.status = status;
    if (delivery_mode) payload.delivery_mode = delivery_mode;
    if (search) payload.search = search;
    if (sort_by) payload.sort_by = sort_by;

    return new Promise((resolve, reject) => {
      PersonalizerApi.post("broadcasts/list", payload, {
        headers: { "project-id": project_id },
      }).then(
        response => {
          const data = response.data?.detail?.response || {};
          commit(SET_BROADCASTS_MESSAGE, {
            items: data.broadcasts || [],
            total: data.total_hits || 0,
          });
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_BROADCAST_MESSAGE](_, { project_id, profile_ids, message, delivery_mode, delivery_time }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `broadcasts`,
        {
          profile_ids,
          message,
          delivery_time,
          delivery_mode,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_BROADCAST_MESSAGE](
    { commit },
    { project_id, broadcast_id, message, profile_ids, delivery_mode, delivery_time }
  ) {
    updateLoaderTo(true);
    const payload = {};
    if (message) payload.message = message;
    if (Array.isArray(profile_ids)) payload.profile_ids = profile_ids;
    if (delivery_time) payload.delivery_time = delivery_time;
    if (delivery_mode) payload.delivery_mode = delivery_mode;
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`broadcasts/${broadcast_id}`, payload, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [DELETE_BROADCAST_MESSAGE]({ commit }, { project_id, broadcast_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`broadcasts/${broadcast_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_PROFILES]({ commit }, { project_id, start, size }) {
    updateLoaderTo(true);
    let uri = `gpt/profiles`;
    if (size) {
      uri = `${uri}?start=${start}&size=${size}`;
    }

    commit(SET_GPT_PROFILES, []);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(uri, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(SET_GPT_PROFILES, response.data?.detail?.response);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_GPT_PROFILE_STATE]({ commit }, { profile }) {
    commit(SET_GPT_PROFILE, profile);
  },
  [UPDATE_GPT_DATASET_STATE]({ commit }, { dataset }) {
    commit(SET_GPT_DATASET, dataset);
  },
  [UPDATE_GPT_SETUP_STATE]({ commit }, value) {
    commit(SET_GPT_SETUP_STATE, value);
  },
  [GET_COUNTRY_LIST]({ commit }, { project_id, socialMediaType = "x" }) {
    commit(SET_COUNTRY_LIST, []);
    const endpoint = `gpt/datasets/social-media/countries`;
    const headers = { "project-id": project_id };
    const params = { social_media_type: socialMediaType };

    return new Promise((resolve, reject) => {
      PersonalizerApi.get(endpoint, { params, headers }).then(
        res => {
          const countryCodes = res?.data?.country_codes || [];
          commit(SET_COUNTRY_LIST, countryCodes);
          updateLoaderTo(false);
          resolve(res);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_DATASETS]({ commit }, { project_id, keyword, sort, is_idx_fillup_if_empty, tags, start, size }) {
    updateLoaderTo(true);
    commit(SET_GPT_DATASETS, []);

    if (!start) start = 0;
    if (!size) size = 10;

    let query = `start=${start}&size=${size}`;
    if (keyword) query = query.concat(`&keyword=${keyword}`);
    if (sort) {
      let key = Object.keys(sort)[0];
      let value = sort[key];
      query = query.concat(`&sort_by_${key}=${value}`);
    }
    if (is_idx_fillup_if_empty !== undefined && is_idx_fillup_if_empty !== "") {
      query = query.concat(`&is_idx_fillup_if_empty=${is_idx_fillup_if_empty}`);
    }
    if (tags && tags.length > 0) {
      query = query.concat(`&tags=${tags.join("&tags=")}`);
    }
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/datasets?${query}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(SET_GPT_DATASETS, response.data);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_DATASETS_SUMMARY]({ commit }, { project_id, dataset_id }) {
    updateLoaderTo(true);
    commit(SET_GPT_DATASET_SUMMARY, {});
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/datasets/${dataset_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(SET_GPT_DATASET_SUMMARY, response.data?.response.dataset);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_ALL_TASKS]({ commit }, { project_id, task_type, task_status, start = 0, size = 10 }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`tasks?task_type=${task_type}&task_status=${task_status}&start=${start}&size=${size}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GPT_DATASET_BY_ID]({ commit }, { project_id, dataset_id }) {
    updateLoaderTo(true);
    commit(SET_GPT_DATASET, gptDatasetInitialData);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/datasets/${dataset_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(SET_GPT_DATASET, GptDatasetMapper.mapBackendToFrontend(response.data?.response.dataset));
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_GPT_DATASET]({ commit }, { project_id, dataset }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const clonedDataset = { ...dataset };
      delete clonedDataset.datasetId;
      delete clonedDataset.datasetFile;
      const mappedGPTDatasetDataFormData = GptDatasetMapper.mapFrontendToBackend(clonedDataset);
      PersonalizerApi.post(`gpt/datasets`, mappedGPTDatasetDataFormData, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(SET_GPT_DATASETS, [{ ...dataset, dataset_id: response.data?.detail?.dataset_id }]);
          commit(SET_GPT_DATASET, {
            ...dataset,
            datasetId: response.data?.detail?.dataset_id,
          });
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  [CREATE_GPT_DATASET_TS]({ commit }, { project_id, dataset }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const clonedDataset = {
        name: dataset.name,
        idx_column_name: dataset.index_column_name,
        description: dataset.description,
        master_timezone: dataset.masterTimezone ?? null,
        naive_policy: dataset.naivePolicy ?? null,
        aware_policy: dataset.awarePolicy ?? null,
        datetime_fields_tz: dataset.datetimeFieldsTz,
        primary_datetime_field: dataset.primaryDatetimeColumn,
        tags: dataset.tags,
        ...(dataset.cloud_update_frequency && {
          cloud_update_frequency: dataset.cloud_update_frequency,
        }),
        ...(dataset.cloud_sync_hours && {
          cloud_sync_hours: dataset.cloud_sync_hours,
        }),
        ...(dataset.cloud_extensions?.length && {
          cloud_extensions: dataset.cloud_extensions,
        }),
      };

      PersonalizerApi.post(`gpt/datasets_ts`, clonedDataset, {
        headers: {
          "project-id": project_id,
          "Content-Type": "application/json",
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  [TERMINATE_GPT_DATASET]({ commit }, { project_id, dataset_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`gpt/datasets/${dataset_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_GPT_DATASET_API]({ commit, dispatch }, { project_id, dataset }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const clonedDataset = { ...dataset };
      delete clonedDataset.datasetId;
      const datasetFile = clonedDataset.datasetFile;
      const is_ocr = clonedDataset.is_ocr;
      const is_text_extraction = clonedDataset.is_text_extraction;
      const metadata = clonedDataset.metadata;
      const cloudSources = clonedDataset.cloudSources || [];
      const datasetId = dataset.datasetId;
      delete clonedDataset.datasetFile;
      let endpoint = `gpt/datasets/${datasetId}`;
      const isTimeSeries = clonedDataset?.dataset_type === "time_series";
      if (isTimeSeries) {
        endpoint = `gpt/datasets_ts/${datasetId}`;
      }
      const mappedGPTDatasetDataFormData = GptDatasetMapper.mapFrontendToBackend(clonedDataset);
      PersonalizerApi.put(endpoint, mappedGPTDatasetDataFormData, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        async response => {
          if (datasetFile && !isTimeSeries) {
            try {
              const fileResponse = await dispatch(UPDATE_GPT_DATASET_FILE, {
                project_id,
                datasetId,
                datasetFile,
                is_ocr,
                is_text_extraction,
                metadata,
              });
              updateLoaderTo(false);
              resolve(fileResponse);
            } catch (error) {
              updateLoaderTo(false);
              reject(error);
            }
          } else if (cloudSources.length && !isTimeSeries) {
            try {
              const cloudResponse = await dispatch(UPDATE_GPT_DATASET_FILE, {
                project_id,
                datasetId,
                cloud_sources: cloudSources,
                is_ocr,
                is_text_extraction,
                metadata,
              });
              updateLoaderTo(false);
              resolve(cloudResponse);
            } catch (error) {
              updateLoaderTo(false);
              reject(error);
            }
          } else {
            updateLoaderTo(false);
            resolve(response);
          }
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  async [UPDATE_GPT_DATASET_FILE](
    { commit },
    {
      project_id,
      datasetId,
      datasetFile,
      cookies_file,
      is_ocr,
      is_text_extraction,
      metadata,
      instant_training = false,
      scrape_urls,
      cloud_sources,
    }
  ) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      if (datasetFile) {
        formData.append("dataset_file", datasetFile);
        formData.append("instant_training", instant_training);

        const isTextExtractable = isTextExtractableFile(datasetFile);
        const isImage = String(datasetFile.type || "").includes("image");
        const isOcrEnabled = is_ocr === true;
        if (isTextExtractable) {
          let isTextExtraction = is_text_extraction === true;
          if (!isOcrEnabled && !isTextExtraction) {
            isTextExtraction = true;
          }
          formData.append("is_ocr", isOcrEnabled);
          formData.append("is_text_extraction", isTextExtraction);
        } else if (isOcrEnabled && isImage) {
          formData.append("is_ocr", isOcrEnabled);
        }

        const metadataForUpload = isOcrEnabled ? metadata : removeOcrMetadata(metadata);

        if (metadataForUpload !== "" && metadataForUpload && (isImage || isTextExtractable)) {
          try {
            const parsed = JSON.parse(metadataForUpload);
            if (parsed && typeof parsed === "object") formData.append("metadata", metadataForUpload);
          } catch (error) {
            console.warn("Invalid JSON metadata:", error);
          }
        }
      } else if (cloud_sources?.length) {
        const payload = cloud_sources.map((s) => ({
          provider: s.provider,
          account_id: s.account_id,
          item_ids: (s.items || []).map((i) => i.id),
        }));
        formData.append("cloud_sources", JSON.stringify(payload));
        formData.append("instant_training", instant_training);
        // The server cannot infer these from a selection it has not fetched yet.
        const isCloudOcr = is_ocr === true;
        formData.append("is_ocr", isCloudOcr);
        formData.append("is_text_extraction", is_text_extraction !== false || !isCloudOcr);
        if (metadata && metadata !== "") {
          try {
            const parsed = JSON.parse(metadata);
            if (parsed && typeof parsed === "object")
              formData.append("metadata", metadata);
          } catch (error) {
            console.warn("Invalid JSON metadata:", error);
          }
        }
      } else if (scrape_urls) {
        formData.append("scrape_urls", scrape_urls);
        if (cookies_file) formData.append("cookies_file", cookies_file);
      }
      PersonalizerApi.put(`gpt/datasets/${datasetId}/file`, formData, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  async [UPDATE_GPT_DATASET_TS_FILE](
    { _commit },
    { project_id, datasetId, datasetFile, cloud_sources }
  ) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      if (cloud_sources?.length) {
        const payload = cloud_sources.map((s) => ({
          provider: s.provider,
          account_id: s.account_id,
          item_ids: (s.items || []).map((i) => i.id),
        }));
        formData.append("cloud_sources", JSON.stringify(payload));
      } else {
        formData.append("dataset_file", datasetFile);
      }

      PersonalizerApi.put(`gpt/datasets_ts/${datasetId}/file`, formData, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  async [CONNECT_CLOUD_STORAGE](_, { project_id, provider }) {
    return PersonalizerApi.get("gpt/cloud-storage/connect", {
      params: { provider },
      headers: { "project-id": project_id },
    });
  },
  async [GET_CLOUD_STORAGE_FILES](
    _,
    { project_id, provider, account_id, folder_id, cursor, limit, extensions, bust_cache }
  ) {
    return PersonalizerApi.get("gpt/cloud-storage/files", {
      params: { provider, account_id, folder_id, cursor, limit, extensions, bust_cache },
      headers: { "project-id": project_id },
    });
  },
  async [GET_CLOUD_STORAGE_ITEMS](
    _,
    { project_id, provider, account_id, item_ids }
  ) {
    return PersonalizerApi.get("gpt/cloud-storage/items", {
      params: { provider, account_id, item_ids: (item_ids || []).join(",") },
      headers: { "project-id": project_id },
    });
  },
  async [VALIDATE_CLOUD_SELECTION](
    _,
    { project_id, provider, account_id, folder_ids, extensions }
  ) {
    return PersonalizerApi.get("gpt/cloud-storage/validate-selection", {
      params: { provider, account_id, folder_ids, extensions },
      headers: { "project-id": project_id },
    });
  },
  async [DOWNLOAD_CLOUD_FILE](_, { project_id, provider, account_id, file_id }) {
    return PersonalizerApi.get("gpt/cloud-storage/download", {
      params: { provider, account_id, file_id },
      headers: { "project-id": project_id },
      responseType: "blob",
    });
  },
  async [GET_CLOUD_STORAGE_ACCOUNTS](_, { project_id, provider }) {
    return PersonalizerApi.get("gpt/cloud-storage/accounts", {
      params: { provider },
      headers: { "project-id": project_id },
    });
  },
  async [COMPLETE_CLOUD_STORAGE](_, { project_id, link_code }) {
    return PersonalizerApi.post("gpt/cloud-storage/complete", null, {
      params: { link_code },
      headers: { "project-id": project_id },
    });
  },
  async [DISCONNECT_CLOUD_STORAGE](_, { project_id, provider, account_id }) {
    return PersonalizerApi.delete("gpt/cloud-storage/disconnect", {
      params: { provider, account_id },
      headers: { "project-id": project_id },
    });
  },
  [LOAD_PROJECT_BY_ID]({ commit }, { project_id, preserveState = true }) {
    updateLoaderTo(true);
    if (preserveState) commit(SET_PROJECT_BY_ID, {});
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}`).then(
        response => {
          if (preserveState) commit(SET_PROJECT_BY_ID, response.data);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [LOAD_PROJECT_COST]({ commit }, { solutionIDList, monthlyPV, monthlyUU, itemCount, subscriptionType }) {
    updateLoaderTo(true);
    commit(SET_PROJECT_COST, {});
    return new Promise((resolve, reject) => {
      Api.post(`projects/cost`, {
        solution_ids: solutionIDList,
        monthly_pv: monthlyPV,
        monthly_uu: monthlyUU,
        item_count: itemCount,
        subscription_type: subscriptionType,
      }).then(
        response => {
          let projectCost = response.data;
          commit(SET_PROJECT_COST, projectCost);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [SAVE_PROJECT](
    { commit },
    {
      name,
      solutionIDList,
      language,
      segmentID,
      industryID,
      solutionTemplateID,
      monthlyPV,
      expectedRPS,
      monthlyUU,
      itemCount,
      autoScaling,
      regionID,
      gpt_purpose,
      gpt_randomness,
      privacyPolicyURL,
      // subscriptionType
    }
  ) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.post(`projects`, {
        name: name,
        solution_ids: solutionIDList,
        language: language,
        segment_id: segmentID,
        industry_id: industryID,
        solution_template_id: solutionTemplateID,
        monthly_pv: monthlyPV,
        expected_rps: expectedRPS,
        monthly_uu: monthlyUU,
        item_count: itemCount,
        auto_scaling: autoScaling,
        region_id: regionID,
        // subscription_type: subscriptionType
        gpt_purpose: gpt_purpose,
        gpt_randomness: gpt_randomness,
        privacy_policy_url: privacyPolicyURL,
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_PROJECT](
    { commit },
    {
      project_id,
      name,
      solutionIDList,
      monthlyPV,
      expectedRPS,
      monthlyUU,
      itemCount,
      autoScaling,
      regionID,
      subscriptionType,
      gpt_purpose,
      gpt_randomness,
      privacy_policy_url: privacyPolicyURL,
    }
  ) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`projects/${project_id}`, {
        name: name,
        solution_ids: solutionIDList,
        monthly_pv: monthlyPV,
        expected_rps: expectedRPS,
        monthly_uu: monthlyUU,
        item_count: itemCount,
        auto_scaling: autoScaling,
        region_id: regionID,
        subscription_type: subscriptionType,
        gpt_purpose: gpt_purpose,
        gpt_randomness: gpt_randomness,
        privacy_policy_url: privacyPolicyURL,
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [START_PROJECT]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/start`).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPGRADE_SUBSCRIPTION]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`projects/${project_id}/upgrade/subscription`).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [STOP_PROJECT]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/stop`).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [TERMINATE_PROJECT]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/terminate`).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [LOAD_ALL_CREDENTIAL]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      commit(SET_ALL_CREDENTIAL, []);
      Api.get(`projects/${project_id}/credentials`).then(
        response => {
          let allCredential = response.data.credentials;

          commit(SET_ALL_CREDENTIAL, allCredential);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GUEST_LINKS](_, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/guest-link`).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_GUEST_LINKS_USERS](
    _,
    { project_id, page = 1, per_page = 10, search, sort_by = "created_at", sort_order = "desc" }
  ) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/guest-link/users`, {
        params: {
          page,
          per_page,
          ...(search ? { search } : {}),
          sort_by,
          sort_order,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  [RESET_GUEST_LINK_USER_PASSWORD](_, { project_id, user_id }) {
    updateLoaderTo(true);

    return new Promise((resolve, reject) => {
      Api.post(`projects/${project_id}/guest-link/user/${user_id}/reset-password`).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_PROJECT_DIRECT_LINK_ACCESS_TYPE]({ commit }, { project_id, guest_link_auth_mode }) {
    updateLoaderTo(true);
    const body = {};
    if (guest_link_auth_mode !== undefined) body.guest_link_auth_mode = guest_link_auth_mode;
    return new Promise((resolve, reject) => {
      Api.patch(`projects/${project_id}`, body).then(
        response => {
          updateLoaderTo(false);
          commit(UPDATE_SELECTED_PROJECT, {
            key: "guest_link_auth_mode",
            value: guest_link_auth_mode,
          });
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  [CREATE_GUEST_LINK](_, { project_id, name, profile_id, project_key_id, default_language }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.post(`projects/${project_id}/guest-link`, {
        name,
        profile_id,
        project_key_id,
        default_language,
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_GUEST_LINK](_, { project_id, link_id, name, status, profile_id, project_key_id, default_language }) {
    updateLoaderTo(true);
    const body = {};
    if (name !== undefined) body.name = name;
    if (status !== undefined) body.status = status;
    if (profile_id !== undefined) body.profile_id = profile_id;
    if (project_key_id !== undefined) body.project_key_id = project_key_id;
    if (default_language !== undefined) body.default_language = default_language;

    return new Promise((resolve, reject) => {
      Api.patch(`projects/${project_id}/guest-link/${link_id}`, body).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [SAVE_CREDENTIAL]({ commit }, { project_id, name, type, whitelisted }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.post(`projects/${project_id}/credentials`, {
        name: name,
        key_type: type,
        key_metadata: whitelisted,
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_CREDENTIAL]({ commit }, { project_id, credential_id, name, type, whitelisted, status }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`projects/${project_id}/credentials/${credential_id}`, {
        name: name,
        key_type: type,
        key_metadata: whitelisted,
        status: status,
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_IP_ACCESS]({ commit }, { project_id, allowed_ip, status, title }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.post(`projects/${project_id}/ip-access`, {
        allowed_ip: allowed_ip,
        status: status,
        title: title,
      })
        .then(response => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },
  [GET_ALL_IP_ACCESS]({ commit }, { page = 1, per_page = 10, sort_by, sort_order, project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(
        `projects/${project_id}/ip-access?page=${page}&per_page=${per_page}&sort_by=${sort_by}&sort_order=${sort_order}`
      )
        .then(response => {
          commit(SET_ALL_IP_ACCESS, response.data);
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },
  [UPDATE_IP_ACCESS]({ commit }, { project_id, access_id, allowed_ip, status, title }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`projects/${project_id}/ip-access/${access_id}`, {
        allowed_ip: allowed_ip,
        status: status,
        title: title,
      })
        .then(response => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },
  [DELETE_IP_ACCESS]({ commit }, { project_id, access_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.delete(`projects/${project_id}/ip-access/${access_id}`)
        .then(response => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },
  [GET_RANK_SETTINGS]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`ranks/settings`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_MAPPER]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`mappers`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          commit(SET_MAPPER, response.data.detail.response);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_MAPPER]({ commit }, { project_id, mapper_body }) {
    let key_map = mapper_body.key_map;
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `mappers`,
        {
          key_map,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_MAPPER]({ commit }, { project_id, mapper_body }) {
    let key_map = mapper_body.key_map;
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(
        `mappers`,
        {
          key_map,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_INDICES]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`indices`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_INDICES]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `indices`,
        {},
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [CREATE_RANK]({ commit }, { project_id, settings }) {
    let rank_settings = settings.rank_settings;
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `ranks/settings`,
        {
          rank_settings,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_RANK_SETTINGS]({ commit }, { project_id, settings }) {
    let rank_settings = settings.rank_settings;
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(
        `ranks/settings`,
        {
          rank_settings,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPLOAD_RECOMMENDER_DATA]({ commit }, { project_id, file }) {
    updateLoaderTo(true);

    return new Promise((resolve, reject) => {
      PersonalizerApi.post(`items/save`, file, {
        headers: {
          "Content-Type": "multipart/form-data",
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [ITEMS_TRAIN]({ commit }, { project_id, train_all, train_from, train_to }) {
    updateLoaderTo(true);
    let uri = `items/train`;
    if (train_from && train_to) {
      uri = uri + `?train_from=${train_from}T00:00:00&train_to=${train_to}T00:00:00`;
    } else {
      uri = uri + `?train_all=${train_all}`;
    }

    return new Promise((resolve, reject) => {
      PersonalizerApi.get(uri, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [IMAGES_TRAIN]({ commit }, { project_id, start_date, end_date }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `images/train`,
        {
          start_date: start_date,
          end_date: end_date,
        },
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [RANKS_TRAIN]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `ranks/train`,
        {},
        {
          headers: {
            "project-id": project_id,
          },
        }
      ).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  async [GET_TASKS_STATUS]({ commit, dispatch }, { project_id }) {
    updateLoaderTo(true);

    const [gptProfiles, defaultProfile, gptDatasets, successfullyProcessedDatasets, successfullyTrained] =
      await Promise.all([
        dispatch(GET_GPT_PROFILES, { project_id }),
        dispatch(GET_GPT_SETTINGS, { project_id }),
        dispatch(GET_GPT_DATASETS, { project_id }),
        dispatch(GET_ALL_TASKS, {
          project_id,
          task_type: "gpt_dataset",
          task_status: "success",
          start: 0,
          size: 1,
        }),
        dispatch(GET_ALL_TASKS, {
          project_id,
          task_type: "gpt_train",
          task_status: "success",
          start: 0,
          size: 1,
        }),
      ]);
    let tasks_status = {
      completed: false,
      gpt_profile: { completed: false, skipped: false, profile_id: null },
      default_profile: { completed: false },
      dataset: {
        task_id: null,
        status: null,
        dataset_id: null,
        completed: false,
        skipped: false,
      },
      training: {
        task_id: null,
        status: null,
        completed: false,
        skipped: false,
      },
    };

    if (gptProfiles.data?.detail?.response?.profiles?.length > 0) {
      tasks_status.gpt_profile.completed = true;
      tasks_status.gpt_profile.profile_id = gptProfiles.data?.detail?.response?.profiles[0]?.id;
    }
    if (defaultProfile.data?.detail?.settings?.default_profile) {
      tasks_status.default_profile.completed = true;
    } else if (tasks_status.gpt_profile.profile_id) {
      dispatch(CREATE_GPT_SETTINGS, {
        project_id,
        default_profile: tasks_status.gpt_profile.profile_id,
      });
      tasks_status.default_profile.completed = true;
    }

    if (successfullyProcessedDatasets.data?.detail?.response?.length > 0) {
      tasks_status.dataset.completed = true;
      tasks_status.dataset.task_id = null;
      tasks_status.dataset.status = successfullyProcessedDatasets.data?.detail?.response[0]?.status;
    }
    tasks_status.dataset.dataset_id = gptDatasets.data?.datasets[0]?.dataset_id;

    if (successfullyTrained.data?.detail?.response?.length > 0) {
      tasks_status.training.completed = true;
      tasks_status.training.task_id = null;
      tasks_status.training.status = successfullyTrained.data?.detail?.response[0]?.status;
    }

    tasks_status.completed =
      tasks_status.gpt_profile.completed && tasks_status.dataset.completed && tasks_status.training.completed;

    updateLoaderTo(false);
    return tasks_status;
  },
  [LOAD_TRAIN_TASKS]({ commit }, { project_id, train_type, status, start, size }) {
    if (!train_type) {
      train_type = "all_tasks";
    }

    if (!status) {
      status = "all_status";
    }
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      commit(SET_TRAIN_TASKS, []);
      PersonalizerApi.get(`tasks`, {
        params: {
          task_type: train_type,
          task_status: status,
          start,
          size,
        },
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          let trainTasks = response.data.detail.response;
          commit(SET_TRAIN_TASKS, trainTasks);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  async [GET_PREVIOUSLY_SETUP_STATE]({ commit, dispatch }, { project_id }) {
    updateLoaderTo(true);
    let previouslySetupState = [
      {
        name: "map_create",
        message: "",
        value: true,
        progress_value: 0,
        status: "failed",
      },
      {
        name: "index_create",
        message: "",
        value: true,
        progress_value: 0,
        status: "failed",
      },
      {
        name: "rank_settings",
        message: "",
        value: true,
        progress_value: 0,
        status: "failed",
      },
      {
        name: "csv_upload",
        message: "",
        value: true,
        progress_value: 0,
        status: "failed",
      },
    ];

    try {
      const [mapper, indices, ranks, items] = await Promise.all([
        dispatch(GET_MAPPER, { project_id }),
        dispatch(GET_INDICES, { project_id }),
        dispatch(GET_RANK_SETTINGS, { project_id }),
        dispatch(LOAD_TRAIN_TASKS, {
          project_id,
          train_type: "item_save",
          status: "success",
          start: 0,
          size: 1,
        }),
      ]);

      if (mapper.data?.detail?.response) {
        previouslySetupState[0].status = "success";
        commit(SET_MAPPER, mapper.data.detail.response);
      }
      if (indices.data?.detail?.response?.length > 0) previouslySetupState[1].status = "success";
      if (ranks.data?.detail?.response) previouslySetupState[2].status = "success";
      if (items.data?.detail?.response?.length > 0) previouslySetupState[3].status = "success";

      commit(SET_PREVIOUSLY_SETUP_STATE, { steps: previouslySetupState });
      commit(SET_PROJECT_SETUP_STATE, previouslySetupState);
    } catch (error) {
      console.error("Error fetching previously setup state:", error);
    } finally {
      updateLoaderTo(false);
    }

    return previouslySetupState; // Return the state
  },
  [LOAD_PROJECT_COUNTS]({ commit }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      commit(SET_PROJECT_COUNTS, []);
      Api.get(`projects/count`).then(
        response => {
          let projectCounts = response.data.counts;
          commit(SET_PROJECT_COUNTS, projectCounts);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  [GET_CATALOG_ITEMS]({ commit }, { project_id, payload }) {
    const data = {
      start_date: payload.start_date,
      end_date: payload.end_date,
      text: payload.text,
      sort: payload.sort,
      ranges: payload.ranges,
      start: payload.start,
      size: payload.size,
    };
    if (payload.scroll_id) {
      data["scroll_id"] = payload.scroll_id;
    }
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(`items/scroll`, data, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          const catalogItems = response.data;
          commit(SET_CATALOG_ITEMS, catalogItems);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [REMOVE_CATALOG_ITEMS]({ commit }, { project_id, item_ids, is_delete_all, documentIds }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`items`, {
        data: {
          ids: item_ids,
          is_delete_all: is_delete_all,
          documentIds: documentIds,
        },
        headers: {
          "Content-Type": "application/json",
          "project-id": project_id,
        },
      })
        .then(response => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },
  [UPDATE_CATALOG_ITEM]({ commit }, { project_id, item_id, payload }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`items/${item_id}`, payload, {
        headers: {
          "project-id": project_id,
        },
      })
        .then(response => {
          updateLoaderTo(false);
          this.selectedItem = response.data;
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          console.error("Error updating catalog item:", error);
          reject(error);
        });
    });
  },
  [GET_GPT_MODELS]({ commit }, { project_id, start = 0, size = 1000 }) {
    updateLoaderTo(true);
    commit(SET_GPT_MODELS, []);
    commit(SET_GPT_PROVIDERS, []);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/models`, {
        params: { start, size },
        headers: {
          "project-id": project_id,
        },
      })
        .then(response => {
          const gptModels = response.data?.detail?.response?.models;
          const gptProviders = response.data?.detail?.response?.providers;
          commit(SET_GPT_MODELS, gptModels);
          commit(SET_GPT_PROVIDERS, gptProviders);
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          console.error("Error fetching GPT modelsss:", error);
          reject(error);
        });
    });
  },
  [GET_GPT_MODEL_DETAILS]({ commit }, { project_id, provider, model }) {
    updateLoaderTo(true);
    if (!provider) {
      provider = "openai";
    }
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/models/${provider}/${model}`, {
        headers: {
          "project-id": project_id,
        },
      })
        .then(response => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch(error => {
          updateLoaderTo(false);
          console.error("Full error object in Vuex action:", error);
          reject(error);
        });
    });
  },
  [DB_GET_TASKS_STATUS]({ commit }, { project_id }) {
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/tasks-status`).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  [DB_STORE_TASKS_STATUS]({ commit }, { project_id, tasks_status }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`projects/${project_id}/tasks-status`, {
        tasks_status,
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GENERATE_FILE]({ commit }, { project_id, gaip_account_id, history_type, start_date, end_date }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`file/generate`, {
        params: {
          gaip_account_id,
          start_date,
          end_date,
          history_type,
        },
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  async [GENERATE_CONVERSATION_HISTORY](
    { commit },
    {
      project_id,
      start_date,
      end_date,
      language,
      feedback_type,
      message_seen,
      request_url,
      profile_id,
      search_text,
      is_archived,
      columns,
    }
  ) {
    updateLoaderTo(true);
    try {
      const url = `files/conversation_history/generate`;
      const payload = {
        start_date,
        end_date,
        language,
        message_seen,
        profile_id,
        search_text,
      };

      // [CSV column selection] Only send `columns` when it is a real, non-empty list. The modal
      // passes null for "default columns", which we leave out entirely so the backend default applies
      // (and so an older backend that doesn't know the field behaves exactly as before).
      if (Array.isArray(columns) && columns.length > 0) {
        payload.columns = columns;
      }

      if (request_url) {
        if (request_url === ENDPOINT_TYPES.ASK) payload.request_url = ENDPOINT_PATHS.ASK;
        if (request_url === ENDPOINT_TYPES.VISION) payload.request_url = ENDPOINT_PATHS.VISION;
        if (request_url === ENDPOINT_TYPES.REALTIME) payload.request_url = ENDPOINT_PATHS.REALTIME;
        if (request_url === ENDPOINT_TYPES.QUESTIONNAIRE) payload.request_url = ENDPOINT_PATHS.QUESTIONNAIRE;
      }

      if (feedback_type) {
        payload.feedback_type = feedback_type;
      }

      if (is_archived !== null && is_archived !== undefined) {
        payload.is_archived = is_archived;
      }

      const config = {
        headers: {
          "project-id": project_id,
        },
      };
      return await PersonalizerApi.post(url, payload, config);
    } catch (error) {
      console.error(error);
    } finally {
      updateLoaderTo(false);
    }
  },
  // [CSV column selection] GET /files/conversation_history/columns?language=en|ja
  async [GET_CONVERSATION_HISTORY_COLUMNS]({ commit }, { project_id, language }) {
    updateLoaderTo(true);
    try {
      const url = `files/conversation_history/columns`;
      const config = {
        headers: {
          "project-id": project_id,
        },
        params: { language },
        timeout: 10000,
      };
      return await PersonalizerApi.get(url, config);
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      updateLoaderTo(false);
    }
  },
  // [CSV column selection - session] GET /files/session_history/columns?language=en|ja
  async [GET_SESSION_HISTORY_COLUMNS]({ commit }, { project_id, language }) {
    updateLoaderTo(true);
    try {
      const url = `files/session_history/columns`;
      const config = {
        headers: {
          "project-id": project_id,
        },
        params: { language },
        timeout: 10000,
      };
      return await PersonalizerApi.get(url, config);
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      updateLoaderTo(false);
    }
  },
  async [FETCH_PROFILE_CONVERSATION_INSIGHTS](
    { commit },
    { project_id, maira_profile_id, start_date, end_date, top_n_topics, top_n_keywords, response_language }
  ) {
    updateLoaderTo(true);
    try {
      const url = `gpt/${maira_profile_id}/conversations/insights`;
      const params = {
        start_date,
        end_date,
        top_n_topics,
        top_n_keywords,
        response_language,
      };
      const config = {
        headers: {
          "project-id": project_id,
        },
        params: params,
      };
      return await PersonalizerApi.get(url, config);
    } catch (error) {
      // eslint-disable-next-line no-useless-catch
      throw error;
    } finally {
      updateLoaderTo(false);
    }
  },
  async [REINDEX_PROJECT]({ commit }, { project_id, payload = {} }) {
    updateLoaderTo(true);
    try {
      const url = `reindex`;
      const config = {
        headers: {
          "project-id": project_id,
        },
      };
      return await PersonalizerApi.post(url, payload, config);
    } catch (error) {
      // eslint-disable-next-line no-useless-catch
      console.error(error);
      throw error;
    } finally {
      updateLoaderTo(false);
    }
  },
  async [GENERATE_SESSION_HISTORY](
    { commit },
    {
      project_id,
      start_date,
      end_date,
      language,
      profile_id,
      session_id,
      session_code,
      search_text,
      is_archived,
      columns,
      include_questionnaire_answers,
    }
  ) {
    updateLoaderTo(true);
    try {
      const url = `files/session_history/generate`;
      const payload = {
        start_date,
        end_date,
        language,
        profile_id,
        session_id,
        session_code,
        search_text,
      };
      if (is_archived !== null && is_archived !== undefined) {
        payload.is_archived = is_archived;
      }
      // [CSV column selection - session] Same rule as conversations: only send `columns` when it
      // is a non-empty list; null/undefined means "all fixed columns" (backend default).
      if (Array.isArray(columns) && columns.length > 0) {
        payload.columns = columns;
      }
      // [CSV column selection - session] Questionnaire toggle. Only sent when it is an actual
      // boolean; backend default is true, so leaving it out keeps today's behaviour.
      if (typeof include_questionnaire_answers === "boolean") {
        payload.include_questionnaire_answers = include_questionnaire_answers;
      }
      const config = {
        headers: {
          "project-id": project_id,
        },
      };
      return await PersonalizerApi.post(url, payload, config);
    } catch (error) {
      console.error(error);
    } finally {
      updateLoaderTo(false);
    }
  },
  async [GENERATE_MAIRA_QUESTIONNAIRE_HISTORY](
    { _commit },
    {
      project_id,
      start_date,
      end_date,
      language,
      profile_ids,
      questionnaire_ids,
      user_id,
      member_id,
      search_text,
      session_id,
    }
  ) {
    updateLoaderTo(true);
    try {
      const url = `files/maira-questionnaire-history/generate`;
      const payload = {
        start_date,
        end_date,
        language,
        profile_ids,
        questionnaire_ids,
        user_id,
        member_id,
        search_text,
        session_id,
      };
      const config = {
        headers: {
          "project-id": project_id,
        },
      };
      return await PersonalizerApi.post(url, payload, config);
    } finally {
      updateLoaderTo(false);
    }
  },
  async [GENERATE_QUESTIONNAIRE_LOGS]({ commit }, { project_id, start_date, end_date, language }) {
    updateLoaderTo(true);
    try {
      const url = `files/questionnaire_logs/generate`;
      const payload = {
        start_date,
        end_date,
        language,
      };
      const config = {
        headers: {
          "project-id": project_id,
        },
      };
      return await PersonalizerApi.post(url, payload, config);
    } catch (error) {
      console.error(error);
    } finally {
      updateLoaderTo(false);
    }
  },
  async [UPDATE_PROJECT_MEMBERS]({ commit }, { projectId, payload, permission_id }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    updateLoaderTo(true);
    try {
      const url = `projects/${projectId}/permission/${permission_id}`;

      return await Api.put(url, payload, config);
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    } finally {
      updateLoaderTo(false);
    }
  },
  async [ASSIGN_PROJECT_MEMBERS]({ commit }, { project_id, users }) {
    updateLoaderTo(true);
    try {
      const url = `projects/${project_id}/users`;

      return await Api.post(url, users);
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    } finally {
      updateLoaderTo(false);
    }
  },

  async [RETRIEVE_PROJECT_MEMBERS]({ commit }, { project_id }) {
    updateLoaderTo(true);
    commit(SET_PROJECT_ASSIGNED_MEMBERS, []);
    try {
      const url = `projects/${project_id}/users`;
      const response = await Api.get(url);
      commit(SET_PROJECT_ASSIGNED_MEMBERS, response?.data?.members);
      return response;
    } catch (error) {
      commit(SET_PROJECT_ASSIGNED_MEMBERS, []);
      console.error(error);
    } finally {
      updateLoaderTo(false);
    }
  },
  async [DELETE_PROJECT_MEMBERS]({ commit }, { project_id, users }) {
    updateLoaderTo(true);
    try {
      const url = `projects/${project_id}/users`;

      return await Api.delete(url, {
        data: users,
      });
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    } finally {
      updateLoaderTo(false);
    }
  },

  [CREATE_SETTINGS]({ commit }, { project_id, embedded_models }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(`settings`, embedded_models, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error.response);
        }
      );
    });
  },
  [UPDATE_SETTINGS]({ commit }, { project_id, embedded_models }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`settings`, embedded_models, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_SETTINGS]({ commit }, { project_id, settingsType, collectionType }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      const url = `settings/${settingsType}?collection_type=${collectionType}`;
      const config = {
        headers: {
          "project-id": project_id,
        },
      };
      PersonalizerApi.get(url, config).then(
        response => {
          updateLoaderTo(false);
          resolve(response?.data?.detail?.response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_MAIRA_OPTIONS]({ commit }, { project_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get(`projects/${project_id}/maira-options`).then(
        response => {
          updateLoaderTo(false);
          commit(SET_MAIRA_OPTIONS, response);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_MAIRA_OPTIONS]({ commit }, { project_id, mairaOptions }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`projects/${project_id}/update-maira-options`, {
        maira_options: { ...mairaOptions },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [MAIRA_QUESTIONNAIRE]({ commit }, { project_id, start_date, end_date, active, start, size }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`maira/questionnaires`, {
        params: {
          start_date,
          end_date,
          active,
          start,
          size,
        },
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_MAIRA_QUESTIONNAIRE]({ commit }, { project_id, questionnaire_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`maira/questionnaire/${questionnaire_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          commit(SET_MAIRA_QUESTIONNAIRE, {
            data: response.data,
            id: questionnaire_id,
          });
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [POST_MAIRA_QUESTIONNAIRE]({ commit }, { project_id, questionnaire_body }) {
    updateLoaderTo(true);

    return new Promise((resolve, reject) => {
      PersonalizerApi.post(`maira/questionnaire`, questionnaire_body, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_MAIRA_QUESTIONNAIRE]({ commit }, { project_id, questionnaire_id, questionnaire_body }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`maira/questionnaire/${questionnaire_id}`, questionnaire_body, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [DELETE_MAIRA_QUESTIONNAIRE]({ commit }, { project_id, questionnaire_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`maira/questionnaire/${questionnaire_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_QUESTIONNAIRE_RESPONSES]({ _dispatch }, { project_id, params }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(`maira/questionnaire-responses`, params, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [GET_QUESTIONNAIRE_RESPONSE_DETAIL]({ _dispatch }, { project_id, response_id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`maira/questionnaire-responses/${response_id}`, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },
  [UPDATE_QUESTIONNAIRE_RESPONSE]({ _dispatch }, { project_id, response_id, params }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`maira/questionnaire-responses/${response_id}`, params, {
        headers: {
          "project-id": project_id,
        },
      }).then(
        response => {
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          reject(error);
        }
      );
    });
  },

  ["SET_CONTENT_SOURCE"]({ commit, state }, source) {
    commit("SET_CONTENT_SOURCE", source);

    const dataset = { ...state.selectedGptDataset };
    if (source === "webUrl") {
      dataset.socialMediaType = null;
      dataset.countryCode = null;
      dataset.socialMediaTrendsLimit = null;
      dataset.socialMediaPostsPerTrend = null;
    } else if (source === "socialMedia") {
      dataset.socialMediaType = "x";
      dataset.urls = null;
      dataset.scrapingMode = null;
      dataset.maxDepth = null;
    }
    state.selectedGptDataset = {
      ...state.selectedGptDataset,
      ...dataset,
    };
  },

  ["SET_DATASET_TYPE"]({ commit, state }, type) {
    commit("SET_DATASET_TYPE", type);

    const dataset = { ...state.selectedGptDataset };

    const clearSocialMediaFields = () => {
      dataset.socialMediaType = null;
      dataset.socialMediaPostsPerTrend = null;
      dataset.socialMediaTrendsLimit = null;
      dataset.countryCode = null;
    };

    if (type === "url") {
      dataset.updateFrequency = dataset.updateFrequency || "monthly";
      dataset.scrapingMode = dataset.scrapingMode || "absolute";
      if (dataset.scrapingMode === "nested") {
        dataset.maxDepth = dataset.maxDepth || null;
      }
      if (dataset.updateFrequency === "custom") {
        dataset.numOfDays = dataset.numOfDays || null;
      }
      dataset.primary_datetime_field = null;
      dataset.datetime_fields = null;
      dataset.datetime_fields_tz = null;
      dataset.master_timezone = null;
      dataset.naive_policy = null;
      dataset.aware_policy = null;

      dataset.datasetFile = null;
      dataset.tags = dataset.tags.filter(item => item !== "dictionary");
    } else if (type === "dictionary") {
      dataset.tags = [...new Set([...dataset.tags, "dictionary"])];

      dataset.urls = null;
      dataset.updateFrequency = null;
      dataset.scrapingMode = null;

      dataset.primary_datetime_field = null;
      dataset.datetime_fields = null;
      dataset.datetime_fields_tz = null;
      dataset.master_timezone = null;
      dataset.naive_policy = null;
      dataset.aware_policy = null;

      clearSocialMediaFields();
    } else if (type === "regular") {
      dataset.urls = null;
      dataset.updateFrequency = null;
      dataset.scrapingMode = null;

      dataset.primary_datetime_field = null;
      dataset.datetime_fields = null;
      dataset.datetime_fields_tz = null;
      dataset.master_timezone = null;
      dataset.naive_policy = null;
      dataset.aware_policy = null;

      dataset.tags = dataset.tags.filter(item => item !== "dictionary");

      clearSocialMediaFields();
    } else if (type === "ts") {
      dataset.urls = null;
      dataset.updateFrequency = null;
      dataset.scrapingMode = null;

      dataset.filterableFields = null;
      dataset.tags = dataset.tags.filter(item => item !== "dictionary");

      clearSocialMediaFields();
    }

    state.selectedGptDataset = {
      ...state.selectedGptDataset,
      ...dataset,
    };
  },
  async [FETCH_SHAREABLE_DATA]({ commit }, { project_id } = {}) {
    updateLoaderTo(true);

    try {
      const headers = project_id ? { "project-id": project_id } : {};
      const resp = await PersonalizerApi.get(`gpt/profiles/external-system/shareable-data`, { headers });

      commit(SET_SHAREABLE_DATA, resp?.data ?? null);
      updateLoaderTo(false);
      return resp;
    } catch (err) {
      updateLoaderTo(false);
      throw err;
    } finally {
      updateLoaderTo(false);
    }
  },

  async [GET_DEFAULT_CATEGORIES]({ commit }, { project_id } = {}) {
    updateLoaderTo(true);

    try {
      const headers = project_id ? { "project-id": project_id } : {};
      const resp = await PersonalizerApi.get(`gpt/profiles/content-moderation/get-default-categories`, { headers });

      commit(SET_DEFAULT_CATEGORIES, resp?.data);
      updateLoaderTo(false);
      return resp;
    } catch (err) {
      updateLoaderTo(false);
      throw err;
    } finally {
      updateLoaderTo(false);
    }
  },

  async [ENCRYPT_EXTERNAL_SYSTEM_DATA]({ commit }, { project_id, body } = {}) {
    if (!project_id) {
      throw new Error("project_id is required");
    }

    updateLoaderTo(true);
    commit(SET_ENCRYPT_RESPONSE, null);

    try {
      const response = await Api.post(`projects/${project_id}/external-system-key`, body);

      commit(SET_ENCRYPT_RESPONSE, response?.data ?? null);
      updateLoaderTo(false);
      return response;
    } catch (error) {
      updateLoaderTo(false);
      throw error;
    }
  },
  [LOAD_EMAIL_CONFIGS]({ commit }, { projectId, page, perPage, sortBy, sortDesc, filters, getAll = false }) {
    updateLoaderTo(true);

    let apiUrl = "";
    if (getAll) {
      apiUrl = `/projects/${projectId}/email-configs?get_all=true`;
    } else {
      // URLSearchParams for a clean and safe way to build the query string
      const params = new URLSearchParams({
        page: page,
        per_page: perPage,
      });

      // sort parameters
      if (sortBy?.length) {
        params.append("sort_by", sortBy[0]);
        params.append("sort_order", sortDesc[0] ? "desc" : "asc");
      }

      // filter parameters
      if (filters) {
        if (filters.email?.trim()) params.append("email", filters.email.trim());
        if (filters.provider?.trim()) params.append("provider", filters.provider.trim());
        if (filters.status?.trim()) params.append("status", filters.status.trim());
      }

      apiUrl = `/projects/${projectId}/email-configs?${params.toString()}`;
    }

    return new Promise((resolve, reject) => {
      Api.get(apiUrl).then(
        response => {
          commit(SET_EMAIL_CONFIGS, response.data);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          commit(SET_EMAIL_CONFIGS, { items: [], total: 0 });
          reject(error);
        }
      );
    });
  },
  [LOAD_EMAIL_PROVIDERS]({ commit }) {
    return new Promise((resolve, reject) => {
      Api.get("/email/providers").then(
        response => {
          commit(SET_EMAIL_PROVIDERS, response.data?.items);
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  [INITIATE_OAUTH_LOGIN](_, { projectId, provider }) {
    return new Promise((resolve, reject) => {
      Api.get(`/auth/${provider}/login?project_id=${projectId}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  [SAVE_SMTP_CONFIG]({ dispatch }, { projectId, payload }) {
    return new Promise((resolve, reject) => {
      Api.post(`/projects/${projectId}/email-configs/smtp`, payload).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  [DELETE_EMAIL_CONFIG]({ dispatch }, { projectId, configId }) {
    return new Promise((resolve, reject) => {
      Api.delete(`/projects/${projectId}/email-configs/${configId}`).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [UPDATE_EMAIL_CONFIG_STATUS]({ dispatch }, { projectId, configId, newStatus }) {
    return new Promise((resolve, reject) => {
      Api.put(`/projects/${projectId}/email-configs/${configId}/status`, {
        status: newStatus,
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [LOAD_EMAIL_RECIPIENTS]({ commit }, { projectId, searchText, start, size, sortBy, sortDesc }) {
    updateLoaderTo(true);
    const params = new URLSearchParams();

    if (searchText?.length) {
      params.append("search_text", searchText);
    }

    if (start !== undefined) {
      params.append("start", start);
    }

    if (size !== undefined) {
      params.append("size", size);
    }

    if (sortBy) {
      params.append("sort_by", sortBy);
      params.append("sort_order", sortDesc ? "desc" : "asc");
    } else {
      // Default sort: created_at desc
      params.append("sort_by", "created_at");
      params.append("sort_order", "desc");
    }

    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`email-recipients?${params.toString()}`, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          const data = response?.data?.detail?.response || { items: [], total: 0 };
          commit(SET_EMAIL_RECIPIENTS, data);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          commit(SET_EMAIL_RECIPIENTS, { items: [], total: 0 });
          reject(error);
        }
      );
    });
  },
  [SAVE_EMAIL_RECIPIENT](_, { projectId, payload }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.post("email-recipients", payload, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [UPDATE_EMAIL_RECIPIENT](_, { projectId, recipientId, payload }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`email-recipients/${recipientId}`, payload, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [DELETE_EMAIL_RECIPIENT](_, { projectId, recipientId }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`email-recipients/${recipientId}`, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [GET_EMAIL_RECIPIENT](_, { projectId, recipientId }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`email-recipients/${recipientId}`, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [LOAD_EMAIL_TEMPLATES]({ commit }, { projectId, searchText, start, size, sortBy, sortDesc }) {
    updateLoaderTo(true);
    const params = new URLSearchParams();

    if (searchText?.length) {
      params.append("search_text", searchText);
    }

    if (start !== undefined) {
      params.append("start", start);
    }

    if (size !== undefined) {
      params.append("size", size);
    }

    // Only allow sorting by created_at or updated_at for templates
    if (sortBy) {
      params.append("sort_by", sortBy);
      params.append("sort_order", sortDesc ? "desc" : "asc");
    } else {
      // Default sort: created_at desc
      params.append("sort_by", "created_at");
      params.append("sort_order", "desc");
    }

    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`email-templates?${params.toString()}`, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          const data = response?.data?.detail?.response || { items: [], total: 0 };
          commit(SET_EMAIL_TEMPLATES, data);
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          updateLoaderTo(false);
          commit(SET_EMAIL_TEMPLATES, { items: [], total: 0 });
          reject(error);
        }
      );
    });
  },
  [SAVE_EMAIL_TEMPLATE](_, { projectId, payload }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.post("email-templates", payload, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [UPDATE_EMAIL_TEMPLATE](_, { projectId, templateId, payload }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`email-templates/${templateId}`, payload, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [DELETE_EMAIL_TEMPLATE](_, { projectId, templateId }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.delete(`email-templates/${templateId}`, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
  [GET_EMAIL_TEMPLATE](_, { projectId, templateId }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`email-templates/${templateId}`, {
        headers: {
          "project-id": projectId,
        },
      }).then(
        response => {
          resolve(response);
        },
        error => reject(error)
      );
    });
  },
};

const mutations = {
  [SET_ALL_PROJECT](state, allProject) {
    state.allProject = allProject;
  },
  [SET_PROJECT_BY_ID](state, selectedProject) {
    state.selectedProject = selectedProject;
    state.project_role = selectedProject.project_role; // set for project role from project details route.
  },
  [SET_MAPPER](state, mapper) {
    state.mapper = mapper;
  },
  [SET_PROJECT_SETUP_STATE](state, projectSetupState) {
    state.selectedProject.setup_state = projectSetupState;
  },
  [SET_GPT_PROFILES](state, gptProfiles) {
    state.gptProfiles = gptProfiles;
  },
  [SET_GPT_DATASETS](state, gptDatasets) {
    state.gptDatasets = gptDatasets;
  },
  [SET_GPT_DATASET](state, selectedGptDataset) {
    state.selectedGptDataset = selectedGptDataset;
  },
  [SET_GPT_DATASET_SUMMARY](state, gptDatasetSummary) {
    state.gptDatasetSummary = gptDatasetSummary;
  },
  [SET_GPT_PROFILE](state, selectedGptProfile) {
    state.selectedGptProfile = selectedGptProfile;
  },
  [SET_MAIRA_QUESTIONNAIRE](state, { data, id }) {
    state.selectedMairaQuestionnaire = {
      ...data,
      id: id,
    };
  },
  [CLEAR_SELECTED_QUESTIONNAIRE](state) {
    state.selectedMairaQuestionnaire = MAIRA_QUESTIONNAIRE_INIT_DATA();
  },
  [SET_GPT_SETUP_STATE](state, value) {
    state.gptSetupState = value;
  },
  [SET_COUNTRY_LIST](state, value) {
    state.countryList = value;
  },
  // [UPDATE_GPT_PROFILE](state, {profile}) {
  //     state.selectedGptProfile = profile;
  // },
  [SET_PROJECT_COST](state, projectCost) {
    state.projectCost = projectCost;
  },
  [SET_ALL_CREDENTIAL](state, allCredential) {
    state.allCredential = allCredential;
  },
  [SET_ALL_IP_ACCESS](state, allIpAddress) {
    state.allowedIp = allIpAddress;
  },
  [SET_TRAIN_TASKS](state, trainTasks) {
    state.trainTasks = trainTasks;
  },
  [SET_PREVIOUSLY_SETUP_STATE](state, previouslySetupState) {
    state.previouslySetupState = previouslySetupState;
  },
  [SET_PROJECT_COUNTS](state, projectCounts) {
    state.projectCounts = projectCounts;
  },
  [SET_CATALOG_ITEMS](state, catalogItems) {
    state.catalogItems = catalogItems;
  },
  [SET_GPT_MODELS](state, gptModels) {
    state.gptModels = gptModels;
  },
  [SET_PROJECT_ASSIGNED_MEMBERS](state, assignedMembers) {
    state.assignedMembers = assignedMembers;
  },
  [SET_GPT_PROVIDERS](state, gptProviders) {
    state.gptProviders = gptProviders;
  },
  [SET_MAIRA_OPTIONS](state, mairaOptions) {
    state.mairaOptions = mairaOptions;
  },
  [SET_EMAIL_CONFIGS](state, paginatedData) {
    state.emailConfigs = paginatedData;
  },
  [SET_EMAIL_PROVIDERS](state, providers) {
    state.emailProviders = providers;
  },
  [SET_EMAIL_RECIPIENTS](state, recipients) {
    state.emailRecipients = recipients;
  },
  [SET_EMAIL_TEMPLATES](state, templates) {
    state.emailTemplates = templates;
  },
  [SET_BROADCASTS_MESSAGE](state, broadcasts) {
    state.broadcasts = broadcasts;
  },
  [CATALOG_SCROLL_ID_STACK](state, { action, value }) {
    switch (action) {
      case "push":
        state.catalogScrollIdStack.push(value);
        break;
      case "pop":
        state.catalogScrollIdStack.pop();
        break;
      case "set":
        state.catalogScrollIdStack = value;
        break;
      case "clear":
        state.catalogScrollIdStack = [];
        break;
      default:
        console.error("Unknown action:", action);
    }
  },
  [SET_PROJECT_ROLE](state, project_role) {
    state.project_role = project_role;
  },
  ["SET_DATASET_TYPE"](state, type) {
    state.datasetType = type;
  },
  ["SET_CONTENT_SOURCE"](state, source) {
    state.contentSource = source;
  },
  [SET_SHAREABLE_DATA](state, payload) {
    if (payload && typeof payload === "object") {
      state.shareableData = payload;
    } else {
      state.shareableData = { ...state.fallbackShareableData };
    }
  },
  [SET_DEFAULT_CATEGORIES](state, payload) {
    if (payload?.detail?.categories && Array.isArray(payload.detail.categories)) {
      state.defaultCategories = payload.detail.categories;
    } else {
      state.defaultCategories = [...state.fallbackCategories];
    }
  },
  [SET_ENCRYPT_RESPONSE](state, payload) {
    state.encryptResponse = payload;
  },
  [UPDATE_SELECTED_PROJECT](state, { key, value }) {
    state.selectedProject = { ...state.selectedProject, [key]: value };
  },
};

export const project = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
